import { setDataset } from './dataset.js';
import { setStyles } from './style.js';


const DEFAULT_IFRAME_ATTRIBUTES = {
    //deprecated attributes that still work, with no valid solutions in css/html
    scrolling: 'no',
    marginWidth: '0',
    marginHeight: '0',
    frameBorder: '0',
}

export interface CreateIframeElementAttributes {
    allowFullscreen?: string;
    scrolling?: string;
    marginWidth?: string;
    marginHeight?: string;
    frameBorder?: string;
    allowTransparency?: string;
    sandbox?: string;
}


export interface CreateIframeElementParameters {
    id?: string;
    src?: string;
    srcdoc?: string;
    styles?: Partial<CSSStyleDeclaration>;
    dataset?: Record<string, string>;
    attributes?: CreateIframeElementAttributes;
}

export const createIframeElement = ({ id, src = '', srcdoc = '',  styles = {}, dataset = {}, attributes = {} }: CreateIframeElementParameters): HTMLIFrameElement => {
    const iframe = document.createElement('iframe');
    const mergedAttributes = {
        ...DEFAULT_IFRAME_ATTRIBUTES,
        ...attributes, //user-defined attributes override defaults, if present
    }

    if (id) iframe.id = id;

    //attributes need to be applied first, before src or srcdoc
    Object.entries(mergedAttributes).forEach(([key, value]) => {
        iframe.setAttribute(key, value);
    })

    setStyles(iframe, {
        border: '0',
        overflow: 'hidden',
        outline: 'none',
        ...styles,
    });
    setDataset(iframe, dataset);

    //src or srcdoc should only be applied after the iframe is fully constructed, otherwise side effects are possible
    if (src) iframe.src = src;
    if (srcdoc) iframe.srcdoc = srcdoc;
    return iframe;
};
